<template>
  <side-nav-section
    :notification="hasNotification"
    :active="$route.name.includes('social')"
    :section="consts.SIDENAV_SOCIAL_SECTION"
    :user="user"
    :stat="sectionTotal"
  >
    <side-nav-item
      v-if="user.isUser"
      :item="consts.SIDENAV_SOCIAL_FRIENDS_ROUTE"
    >
      <span class="number" v-if="user.friend_requests_count">
        {{ user.friend_requests_count }}
      </span>
    </side-nav-item>
    <side-nav-item
      v-if="user.isExpert || user.isProvider"
      :item="consts.SIDENAV_SOCIAL_CLIENTS_ROUTE"
    >
      <span
        class="number"
        v-if="
          user.client_join_requests_count || user.clients_list_requests_count
        "
      >
        {{ user.client_join_requests_count + user.clients_list_requests_count }}
      </span>
    </side-nav-item>
    <side-nav-item
      v-if="!user.isValidator"
      :item="consts.SIDENAV_SOCIAL_GROUPS_ROUTE"
    >
      <span
        class="number"
        v-if="user.team_invites_count || user.team_requests_count"
      >
        {{ user.team_invites_count + user.team_requests_count }}
      </span>
    </side-nav-item>
    <side-nav-item
      v-if="user.isUser"
      :item="consts.SIDENAV_SOCIAL_COACHES_ROUTE"
    >
      <span
        class="number"
        v-if="
          user.coach_requests_count ||
          user.module_invites_count ||
          user.data_connection_requests_count
        "
      >
        {{
          user.coach_requests_count +
          user.module_invites_count +
          user.data_connection_requests_count
        }}
      </span>
    </side-nav-item>
    <side-nav-item :item="consts.SIDENAV_SOCIAL_MESSAGES_ROUTE">
      <span class="number" v-if="user.unread_count">{{
        user.unread_count
      }}</span>
    </side-nav-item>
    <side-nav-item :item="consts.SIDENAV_SOCIAL_NOTIFICATIONS_ROUTE">
      <span class="number" v-if="user.unread_notifications_count">
        {{ user.unread_notifications_count }}
      </span>
    </side-nav-item>
  </side-nav-section>
</template>

<script>
import {
  SIDENAV_SOCIAL_SECTION,
  SIDENAV_SOCIAL_FRIENDS_ROUTE,
  SIDENAV_SOCIAL_CLIENTS_ROUTE,
  SIDENAV_SOCIAL_GROUPS_ROUTE,
  SIDENAV_SOCIAL_MESSAGES_ROUTE,
  SIDENAV_SOCIAL_NOTIFICATIONS_ROUTE,
  SIDENAV_SOCIAL_COACHES_ROUTE,
} from "Consts/sideNav/socialSection";
import SideNavSection from "Public/components/SideNav/SideNavSections/SideNavSection";
import SideNavItem from "Public/components/SideNav/SideNavItem";
export default {
  name: "SocialSection",
  components: { SideNavItem, SideNavSection },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sectionTotal() {
      const {
        unread_count,
        unread_notifications_count,
        friend_requests_count,
        team_invites_count,
        team_requests_count,
        client_join_requests_count,
        coach_requests_count,
        clients_list_requests_count,
        module_invites_count,
        data_connection_requests_count,
      } = this.user;
      return (
        unread_count +
        unread_notifications_count +
        friend_requests_count +
        team_requests_count +
        client_join_requests_count +
        team_invites_count +
        coach_requests_count +
        clients_list_requests_count +
        module_invites_count +
        data_connection_requests_count
      );
    },
    hasNotification() {
      return this.sectionTotal > 0;
    },
  },
  data() {
    return {
      consts: {
        SIDENAV_SOCIAL_SECTION,
        SIDENAV_SOCIAL_FRIENDS_ROUTE,
        SIDENAV_SOCIAL_CLIENTS_ROUTE,
        SIDENAV_SOCIAL_GROUPS_ROUTE,
        SIDENAV_SOCIAL_MESSAGES_ROUTE,
        SIDENAV_SOCIAL_NOTIFICATIONS_ROUTE,
        SIDENAV_SOCIAL_COACHES_ROUTE,
      },
    };
  },
};
</script>

<style scoped></style>
